import React, { useEffect } from 'react';
import clsx from 'clsx';

// import material-ui core styles & color
import { makeStyles, useTheme } from '@material-ui/core/styles';

// import material-ui core components

import useMediaQuery from '@material-ui/core/useMediaQuery';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Backdrop from '@material-ui/core/Backdrop';

// import ThemeContext
import { useMuiThemeContext } from './../../contexts/ThemeContext';

// import material-ui icons
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AppsIcon from '@material-ui/icons/Apps';

import { useRouteMatch } from 'react-router-dom';

import { base64, logger } from './../../utils/utils';

// Depentdency for Specific Custom  Component in MaterLayout (Ex InnerAppBar, InnerSidebar, BreadcrumbsList)

// import NestedAppBar
import InnerAppBar from './InnerAppBar';

// import InnerSidebar (InnerSidebar consist of menu / another thing in sidebar-left)
import InnerSidebar from './InnerSidebar';

// import sufaceStyle
import { appBarStyles } from './../../styles/globalStyles/surfaceStyles';

import { drawer } from './../../constants';

// import routers
import {
  listRoutFrontOf,
  listRoutBackOf,
  PATH_BACKOF_MASTER,
} from './../../routers';

// import BreadcrumbsList
import BreadcrumbsList from './../fragments/BreadcrumbsList';

/**
 * MasterLayout
 *
 * Compoentnt Dependency
 *  - Drawer "persistent both sides" adapted from material-ui drawer
 *
 * Custom log
 * 1 Adapting "persistent right" drawer to main drawer of app
 * 2 Custom some class of "persistent right"  with class of "clipped" (Upder appBar)
 * 3 Update some class & valiable name with *Right suffix, ex. handleDrawerOpen to handleDrawerRightOpen
 * 4 Combile "persistent" (default/left drawer) and update, content, contentShift class and create contentLeftShiftMargin, contentLeftRightMargin class
 * 5 Change name to MasterLayout and add props. ex. title, color and etc.
 * 6 Add appToolBar (Secondary AppBar) consist of BreadcrumbsList
 * 7 Disabled content transition
 */

const drawerWidth = drawer.width;
const drawerRightWidth = drawer.rightWidth;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    // Custom "persistent right" class appBar by clipped zIndex prop.
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  title: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
  },

  // "persistent" (default, left) menuButton class
  menuButton: {
    marginRight: theme.spacing(1),
  },
  menuButtonRight: {
    marginLeft: theme.spacing(1),
  },

  hide: {
    display: 'none',
  },

  // "persistent" (default, left) drawer class
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },

  drawerRight: {
    width: drawerRightWidth,
    flexShrink: 0,
  },
  drawerRightPaper: {
    width: drawerRightWidth,
  },

  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },

  drawerHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
    // * Disabled - Original content transition "leavingScreen" below
    // transition: theme.transitions.create("margin", {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen,
    // }),
  },

  contentMarginLeft: {
    marginLeft: -drawerWidth,
  },

  contentMarginRight: {
    marginRight: -drawerRightWidth,
  },

  contentShift: {
    // * Disabled - Original contentShift transition "enteringScreen" below
    // transition: theme.transitions.create("margin", {
    //   easing: theme.transitions.easing.easeOut,
    //   duration: theme.transitions.duration.enteringScreen,
    // }),
    // // Original contentShift, Custom to class contentLeftShiftMargin
    // marginRight: 0,
  },

  contentLeftShiftMargin: {
    // If breakpoints > sm contentLeftShiftMargin = 0
    [theme.breakpoints.up('sm')]: {
      marginLeft: 0,
    },
  },

  contentRightShiftMargin: {
    [theme.breakpoints.up('sm')]: {
      marginRight: 0,
    },
  },

  // Style of Secondary AppBar
  // Use appBarStyles (consist of appToolBarStyle and etc)
  ...appBarStyles(theme),
  appToolBarShift: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      // * Disabled - Original appToolBarShift transition "enteringScreen" below
      // transition: theme.transitions.create(["margin", "width"], {
      //   easing: theme.transitions.easing.easeOut,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
      marginLeft: drawerWidth,
    },
  },
  appToolBarRightShift: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerRightWidth}px)`,
      // * Disabled - Original appToolBarRightShift transition "enteringScreen" below
      // transition: theme.transitions.create(["margin", "width"], {
      //   easing: theme.transitions.easing.easeOut,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
      marginRight: drawerRightWidth,
    },
  },
  appToolBarLeftRightShift: {
    width: `calc(100% - ${drawerWidth + drawerRightWidth}px)`,
    // * Disabled - Original appToolBarLeftRightShift transition "enteringScreen" below
    // transition: theme.transitions.create(["margin", "width"], {
    //   easing: theme.transitions.easing.easeOut,
    //   duration: theme.transitions.duration.enteringScreen,
    // }),
    marginLeft: drawerWidth,
    marginRight: drawerRightWidth,
  },

  backdrop: {
    zIndex: theme.zIndex.drawer - 1,
    color: '#fff',
  },
}));

/**
 * MasterLayout
 * @param {object} props
 * @param {string} id  id of MasterLayout (default: 'id')
 * @param {string} muiTheme 'frontOffice' | 'backOffice' (default: 'fontOffice')
 */
function MasterLayout({
  id = 'id',
  isAuthen = false,
  muiTheme,
  sidebar = false,
  sidebarRight = false,
  children,
}) {
  logger(`MasterLayout ${id} render`);

  const classes = useStyles();
  const match = useRouteMatch();
  const theme = useTheme();
  const setMuiTheme = useMuiThemeContext();

  const [openDrawer, setOpenDrawer] = React.useState(true);
  const [openDrawerRight, setOpenDrawerRight] = React.useState(true);
  const isMobileSide = useMediaQuery('(max-width: 600px)');

  // handleDrawer (default, left-side)
  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };
  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  // handleDrawer right
  const handleDrawerRightOpen = () => {
    setOpenDrawerRight(true);
  };
  const handleDrawerRightClose = () => {
    setOpenDrawerRight(false);
  };

  // Check muiTheme
  useEffect(() => {
    setMuiTheme(muiTheme);
  }, [muiTheme]);

  // Check mobile-side (isMobileSide)
  useEffect(() => {
    if (!isMobileSide) {
      if (sidebar) {
        handleDrawerRightClose();
      }
      if (sidebarRight) {
        handleDrawerRightOpen();
      }
    } else {
      handleDrawerClose();
      handleDrawerRightClose();
    }
  }, [sidebar, sidebarRight, isMobileSide]);

  // InnerAppBar props
  const breadcrumbs = [...listRoutFrontOf, ...listRoutBackOf].filter((rout) =>
    match.path.includes(rout.path)
  )
  .map((rout)=>{
    if(rout.path.indexOf(':sid')!=-1) {
      rout.title = base64.decode(match.params.sid)
    }
    return rout;
  });

  // InnerAppBar - InnerSidebar props argument;
  const isBackOffice = React.useMemo(
    () => match.path.startsWith(PATH_BACKOF_MASTER),
    [match.path]
  );

  // // Log check component render, prop and state of component,
  // logger(`MasterLayout ${id} render`, {
  //   isMobileSide,
  //   sidebar,
  //   sidebarRight,
  //   openDrawer,
  //   openDrawerRight,
  // });

  return (
    <div className={classes.root}>
      <CssBaseline />

      {/* @Appbar */}
      <AppBar
        position="fixed"
        // // Original AppBar className of "persistent right"
        // className={clsx(classes.appBar, {
        //   [classes.appBarShift]: open,
        // })}

        // Custom AppBar className by "clipped"
        className={classes.appBar}
        // Set prop:color
        color="primary"
      >
        {/* @Toolbar of AppBar */}
        <Toolbar>
          {/* @Sidebar-Left MenuIcon */}
          {sidebar && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerOpen}
              className={clsx(classes.menuButton, {
                [classes.hide]: openDrawer,
              })}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Put inner-AppBar component/code down here */}

          {/* @InnerAppBar */}
          <InnerAppBar isAuthen={isAuthen} isBackOffice={isBackOffice} />

          {/* Sidebar-Left MenuIcon */}
          {sidebarRight && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerRightOpen}
              className={clsx(classes.menuButtonRight, {
                [classes.hide]: openDrawerRight,
              })}
            >
              <AppsIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      {/*AppToolBar (Secondary AppBar) */}
      {isAuthen && (
        <AppBar
          position="fixed"
          className={clsx(classes.appToolBarStyle, {
            [classes.appToolBarShift]: openDrawer,
            [classes.appToolBarRightShift]: openDrawerRight,
            [classes.appToolBarLeftRightShift]: openDrawer && openDrawerRight,
          })}
        >
          <Toolbar className={classes.toolbarStyle}>
            <div style={{ padding: 0, margin: 0, width: '100%' }}>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-evenly"
              >
                <Box flexGrow={1}>
                  <BreadcrumbsList breadcrumbs={breadcrumbs} />
                </Box>
                <Divider orientation="vertical" flexItem />
                <Box
                  flexGrow={1}
                  style={{
                    textAlign: 'right',
                  }}
                >
                  {/* ตัวเลือก ... */}
                </Box>
              </Box>
            </div>
          </Toolbar>
        </AppBar>
      )}

      {/* @Sidebar-Left Drawer */}
      {sidebar && (
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={openDrawer}
          classes={{
            paper: classes.drawerPaper,
          }}
          transitionDuration={0}
        >
          <Toolbar />
          <div className={classes.drawerHeader}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'ltr' ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </div>
          <Divider />

          {/* Put inner-Sidebar component/code down here */}
          <InnerSidebar isBackOffice={isBackOffice} />
        </Drawer>
      )}

      {/* @Main Content */}

      <main
        className={clsx(classes.content, {
          [classes.contentMarginLeft]: sidebar,
          [classes.contentMarginRight]: sidebarRight,
          [classes.contentShift]: openDrawer || openDrawerRight,
          [classes.contentLeftShiftMargin]: openDrawer,
          [classes.contentRightShiftMargin]: openDrawerRight,
        })}
      >
        <div className={classes.toolbarOffsetStyle} />
        <div className={classes.drawerHeaderRight} />
        {/* {JSON.stringify(matches)} */}
        {children}
        <Backdrop
          className={classes.backdrop}
          open={openDrawer && isMobileSide}
          transitionDuration={0}
        />
      </main>

      {/* @Sidebar-Right Drawer  */}
      {sidebarRight && (
        <Drawer
          className={classes.drawerRight}
          variant="persistent"
          anchor="right"
          open={openDrawerRight}
          classes={{
            paper: classes.drawerRightPaper,
          }}
          transitionDuration={0}
        >
          <Toolbar />
          <div className={classes.drawerHeaderRight}>
            {/* Original "persistant drawer rigth" Chevron*Icon */}
            {/* <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton> */}

            {/* Custom  Chevron*Icon for "clipped under the app bar" */}
            <IconButton
              onClick={() => {
                if (!openDrawerRight) {
                  handleDrawerRightOpen();
                } else {
                  handleDrawerRightClose();
                }
              }}
            >
              {!openDrawerRight && <ChevronLeftIcon />}
              {openDrawerRight && <ChevronRightIcon />}
            </IconButton>
          </div>
          <Divider />
          {sidebarRight}
        </Drawer>
      )}
    </div>
  );
}

export default React.memo(MasterLayout);
